import { MessageDeliveryStatus, PushDeliveryStatus } from '../../types';

/**
 * Status badges shared by every delivery audit table — messages and
 * observations both project deliveries to the same UNREAD/READ +
 * PENDING/SENT/FAILED/SKIPPED state machine, so the chips render
 * the same way too.
 */

export function DeliveryStatusBadge({ status }: { status: MessageDeliveryStatus }) {
  const colours =
    status === MessageDeliveryStatus.READ
      ? 'bg-blue-100 text-blue-700'
      : 'bg-yellow-100 text-yellow-700';
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${colours}`}
    >
      {status}
    </span>
  );
}

export function PushStatusBadge({ status }: { status?: PushDeliveryStatus }) {
  if (!status) return <span className="text-gray-400 text-xs">—</span>;
  const colours: Record<PushDeliveryStatus, string> = {
    [PushDeliveryStatus.SENT]: 'bg-green-100 text-green-700',
    [PushDeliveryStatus.PENDING]: 'bg-yellow-100 text-yellow-700',
    [PushDeliveryStatus.FAILED]: 'bg-red-100 text-red-700',
    [PushDeliveryStatus.SKIPPED]: 'bg-gray-100 text-gray-600',
  };
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${colours[status]}`}
    >
      {status.charAt(0) + status.slice(1).toLowerCase()}
    </span>
  );
}
